import React from "react";
import {
  Row,
  Col,
  Label,
  FormGroup,
  Modal,
  ModalBody,
  Button,
} from "reactstrap";
import ReactDatetime from "react-datetime";
import PropTypes from "prop-types";
import moment from "moment";
import "moment/locale/pt-br";
import "./styles.css";

const DATE_FORMAT = "DD/MM/YYYY";
const momentLikePropType = PropTypes.oneOfType([PropTypes.object, PropTypes.string]);

// PO1-3392: `tipoData`/`onTipoData`/`opcoesTipoData` (seletor "Período por") e
// `children` (controles extras, ex.: "Com divergência") são OPCIONAIS: só
// aparecem quando informados, e as outras telas que usam o modal não mudam.
export default function ModalFilters({
  dataInicial,
  dataFinal,
  open,
  toggle,
  handleDateInicial,
  handleDateFinal,
  onSubmit,
  tipoData,
  onTipoData,
  opcoesTipoData,
  children,
}) {
  const dateInitial = moment(dataInicial);

  const initialDateIsValid = (current) => {
    return current.isSameOrBefore(moment(), "day");
  };

  const finalDateIsValid = (current) => {
    if (!dateInitial.isValid()) return false;
    return current.isSameOrAfter(dateInitial, "day");
  };

  return (
    <Modal
      isOpen={open}
      toggle={toggle}
      fade={false}
      wrapClassName="custom-modal-filters-wrap"
      modalClassName="custom-modal-filters-modal"
      className="custom-modal-filters-dialog"
    >
      <div className="custom-modal-filters__header">
        <span className="custom-modal-filters__title">Filtrar período</span>
        <button
          type="button"
          onClick={toggle}
          className="custom-modal-filters__close"
          aria-label="Fechar"
        >
          ×
        </button>
      </div>
      <ModalBody className="text-center custom-modal-filters__body">
        <div className="modal-filters-wrapper">
          {Array.isArray(opcoesTipoData) && opcoesTipoData.length > 0 && typeof onTipoData === "function" ? (
            <Row className="modal-filters-wrapper__row">
              <Col md="12">
                <Label className="custom-modal-filters__label">Período por</Label>
                <div
                  role="group"
                  aria-label="Período por"
                  style={{ display: "flex", justifyContent: "center", gap: "0.5rem", flexWrap: "wrap", marginBottom: "0.75rem" }}
                >
                  {opcoesTipoData.map((opt) => {
                    const ativo = opt.value === tipoData;
                    return (
                      <Button
                        key={opt.value}
                        type="button"
                        size="sm"
                        color={ativo ? "info" : "secondary"}
                        outline={!ativo}
                        className="btn-round"
                        aria-pressed={ativo}
                        onClick={() => onTipoData(opt.value)}
                      >
                        {opt.label}
                      </Button>
                    );
                  })}
                </div>
              </Col>
            </Row>
          ) : null}
          <Row className="modal-filters-wrapper__row">
            <Col md="6">
              <Label className="custom-modal-filters__label">Data inicial</Label>
              <FormGroup className="custom-modal-filters__field custom-modal-filters__field--start">
                <ReactDatetime
                  inputProps={{
                    className: "form-control text-center custom-modal-filters__input",
                    placeholder: "Data inicial",
                    readOnly: true,
                  }}
                  onChange={handleDateInicial}
                  isValidDate={initialDateIsValid}
                  value={dataInicial}
                  timeFormat={false}
                  closeOnSelect
                  locale="pt-br"
                  dateFormat={DATE_FORMAT}
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <Label className="custom-modal-filters__label">Data final</Label>
              <FormGroup className="custom-modal-filters__field custom-modal-filters__field--end">
                <ReactDatetime
                  inputProps={{
                    className: "form-control text-center custom-modal-filters__input",
                    placeholder: "Data final",
                    readOnly: true,
                  }}
                  onChange={handleDateFinal}
                  isValidDate={finalDateIsValid}
                  value={dataFinal}
                  timeFormat={false}
                  closeOnSelect
                  locale="pt-br"
                  dateFormat={DATE_FORMAT}
                />
              </FormGroup>
            </Col>
          </Row>
          {children ? <div className="custom-modal-filters__extras">{children}</div> : null}
          <hr className="custom-modal-filters__divider" />
          <Row className="justify-content-center">
            <Button
              className="btn-round custom-modal-filters__submit"
              color="info"
              onClick={onSubmit}
            >
              Aplicar
            </Button>
          </Row>
        </div>
      </ModalBody>
    </Modal>
  );
}

ModalFilters.propTypes = {
  dataInicial: momentLikePropType.isRequired,
  dataFinal: momentLikePropType.isRequired,
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  handleDateInicial: PropTypes.func.isRequired,
  handleDateFinal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  tipoData: PropTypes.string,
  onTipoData: PropTypes.func,
  opcoesTipoData: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string.isRequired, label: PropTypes.string.isRequired })
  ),
  children: PropTypes.node,
};
